function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), React.createElement("path", {
  d: "M8 3.73l6.5 3.7V15a1 1 0 01-1 1H10v-5a1 1 0 00-1-1H7a1 1 0 00-1 1v5H2.5a1 1 0 01-1-1V7.43L8 3.73zM8.4.08l7 4A1 1 0 0115.02 6L8 2 .97 6a1 1 0 01-.36-1.92l7-4a1 1 0 01.79 0z"
})));